import { createContext } from 'react';

export const PartnerDetails = createContext("");